import { Modal, ControlledPopup, Button, STATUS_TYPES, Notification } from 'dyl-components';
import React from 'react';
import TaskForm from 'shared/NewTasksTab/subcomponents/TaskForm';
import { Icon } from 'semantic-ui-react';
import { useDispatch } from 'react-redux';
import textActions from 'actions/text';
import uploadActions from 'actions/upload';

const AddTaskModal = ({ open,
    onClose,
    taskBeingEdited,
    isAllowedToModify = true,
    onToggleFormTab,
    control,
    watch,
    isValid,
    isDirty,
    trigger,
    setValue,
    getValues,
    reset,
    state,
    addTask,
    onDelete,
    onUpdate,
    onRefresh,
    isDeletingTask,
    isReadingTask,
    task_labels,
    isReadingTaskLabels,
    record_type,
    organizer,
    organizer_email,
    organizer_id,
    clearErrors,
    setError,
    handleSubmit,
    email,
    hiddenContactSelector = false,
    to_phone = null,
    from_phone = null
}) => {
    const onSave = (values) => addTask(values, onRefresh);
    const onEdit = (values) => onUpdate(values, onRefresh)
    const onDeleteTask = () => onDelete(taskBeingEdited.id, onRefresh)
    const dispatch = useDispatch();
    const onSendText = async (data) => {
        try {
            const textBody = {
                from: from_phone,
                to: to_phone,
                message: data.message,
                contact_id: Number(data.contact_id)
            };
            const attachments = data.attachments ?? [];

            const { existingAttachments, filesToSend } = attachments.reduce(
                (acc, item) => {
                    if (item instanceof File) {
                        acc.filesToSend.push(item);
                    } else {
                        acc.existingAttachments.push(item);
                    }
                    return acc;
                },
                { existingAttachments: [], filesToSend: [] }
            );
            await dispatch(textActions.sendText({
                ...textBody,
                attachments: await (async () => {
                    if (filesToSend?.length) {
                        const files = await dispatch(uploadActions.uploadFiles(filesToSend, 'text', [], textBody.contact_id, true));
                        return [...existingAttachments.map(file => ({ id: file.file_id, url: file.url })), ...files.map(file => ({ id: file.id, url: file.url }))];
                    }
                    return existingAttachments.map(file => ({ id: file.file_id, url: file.url }));
                })()
            }))
            onEdit({ ...data, complete: true })
            Notification.alert('Successfully sent text!', STATUS_TYPES.SUCCESS, true);
        } catch (error) {
            console.log("Send Text Error", error)
            Notification.alert('Failed to send text!', STATUS_TYPES.ERROR, true);
        }

    }
    const isCompleted = watch("complete") === true
    return (
        <Modal open={open} onClose={onClose}>
            <Modal.Header>{taskBeingEdited?.name ? taskBeingEdited.name : "New task"}</Modal.Header>
            <Modal.Content scrolling>
                <TaskForm
                    isModal
                    hiddenContactSelector={hiddenContactSelector}
                    relatedTo={state.relatedTo}
                    isAllowedToModify={isAllowedToModify}
                    isTaskTypeDisabled={taskBeingEdited?.name}
                    onClose={onToggleFormTab}
                    refresh={() => {}}
                    {...taskBeingEdited}
                    isSaving={state.saving}
                    isDeleting={isDeletingTask}
                    isReading={isReadingTask}
                    taskTypes={[
                        {
                            key: 'To-Do', value: 'To-Do', text: (
                                <div>
                                    <Icon className='fad fa-check-circle' color='blue' /> To Do
                                </div>
                            )
                        },
                        {
                            key: 'Call', value: 'Call', text: (
                                <div>
                                    <Icon flipped className='fas fa-circle-phone' color='blue' /> Call
                                </div>
                            )
                        },
                        {
                            key: 'Text', value: 'Text', text: (
                                <div>
                                    <Icon className='fas fa-comment' color='blue' /> Text
                                </div>
                            )
                        },
                        {
                            key: 'Email', value: 'Email', text: (
                                <div>
                                    <Icon className='fas fa-circle-envelope' color='blue' /> Email
                                </div>
                            )
                        }
                    ]}
                    task_labels={task_labels}
                    isReadingLabels={isReadingTaskLabels}
                    searchValue={organizer}
                    recordType={record_type}
                    organizer={organizer}
                    organizer_email={organizer_email}
                    organizer_id={organizer_id}
                    control={control}
                    watch={watch}
                    isValid={isValid}
                    isDirty={isDirty}
                    trigger={trigger}
                    setValue={setValue}
                    getValues={getValues}
                    clearErrors={clearErrors}
                    setError={setError}
                    reset={reset}
                    onUpdate={onEdit}
                    email={email}
                />
            </Modal.Content>
            {watch("task_type") === "Text" ? <Modal.Actions hasSaveButton saveOptions={{ text: "Send Text" }} onSave={handleSubmit(onSendText)} saveDisabled={!isValid || isCompleted} primaryChildren={[
                <Button disabled={!isValid || !isDirty || isCompleted} onClick={taskBeingEdited?.id ? handleSubmit(onEdit) : handleSubmit(onSave)} primary>
                    Save
                </Button>
            ]} >
                {taskBeingEdited?.id && (
                    <ControlledPopup
                        trigger={<Button status={"cancel"} basic disabled={!isAllowedToModify}>Delete</Button>}
                        onConfirm={onDeleteTask}
                    />
                )}

            </Modal.Actions> : <Modal.Actions hasSaveButton onSave={taskBeingEdited?.id ? handleSubmit(onEdit) : handleSubmit(onSave)} saveDisabled={!isValid || !isDirty} >
                {taskBeingEdited?.id && (
                    <ControlledPopup
                        trigger={<Button status={"cancel"} basic disabled={!isAllowedToModify}>Delete</Button>}
                        onConfirm={onDeleteTask}
                    />
                )}
            </Modal.Actions>}
        </Modal>
    )
}

export default AddTaskModal;